import { h, Component } from 'preact';
import Store from 'store/store';
import 'store/member';
import { joinClasses } from 'utils/utils';
import HTML from 'components/core/html/html';
import OverlayBackButton from 'components/bolt/overlayBackButton/overlayBackButton';
import s from 'components/bolt/earlyAccessInfoModal/earlyAccessInfoModal.sss';

export default class EarlyAccessInfoModal extends Component {

	onBack() {
		Store.emit('SHOW_EARLY_ACCESS_INFO_MODAL', false);
	}

	render({ show, client, appData }) {
		const copy = appData?.copy?.baseCopy || {};
		return (
			<div class={joinClasses(s.container, show && s.show)}>
				<OverlayBackButton ariaLabel="close" type="back" onClick={this.onBack} client={client} />
				<div class={s.modal}>
					<p class={s.modalTitle}>{copy.$EARLY_ACCESS_INFO_MODAL_TITLE}</p>
					<HTML
						class={s.modalBody}
						markdown
						content={copy.$EARLY_ACCESS_INFO_MODAL}
					/>
					<button class={s.btn} onClick={this.onBack}>
						{copy.$BACK_TO_LISTINGS}
					</button>
				</div>
			</div>
		);
	}
}